import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { CourseProgress } from "src/app/shared/interfaces/course-progress";
import { Guid } from "src/app/shared/types/guid";

export const rankingOrganizationPrefix = "[Set Ranking In Organiztion]";

const rankingOrganizationActions = {
  request: `${rankingOrganizationPrefix} Load`,
  requestActiveSuccess: `${rankingOrganizationPrefix} Load Ranking In Organization success`,
  requestFail: `${rankingOrganizationPrefix} Load fail`,
};

export const rankingOrganizationLoad = createAction(
  rankingOrganizationActions.request,
  props<{
    OrganizationId: Guid;
    in_ranking: boolean;
    notificationMessage?: string;
  }>(),
);

export const rankingOrganizationLoadSuccess = createAction(
  rankingOrganizationActions.requestActiveSuccess,
  props<{ in_ranking: boolean }>(),
);

export const rankingOrganizationFailure = createAction(
  rankingOrganizationActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);
